import { LocaleString } from "./types"

const messages: {

    [key: string]: {
        msg: string | string[]
        error: boolean
    }

} = {

    invalid_connection: {
        msg: "Invalid connection. Please disconnect and reconnect from the remote application." as LocaleString,
        error: true
    },

    org_unknown: {
        msg: "The remote organisation associated with this holding is unknown" as LocaleString,
        error: true
    },

    org_notset: {
        msg: "The remote organisation associated with this holding has not been set" as LocaleString,
        error: true
    },

    no_changes: {
        msg: "No changes have been detected" as LocaleString,
        error: false
    },

    outgoing_scheduled: {
        msg: "Your request has been recorded. Pending changes will be sent to GLGM in the background." as LocaleString,
        error: false
    },

    pending_incoming_changes: {
        msg: [
            "Changes cannot be sent to GLGM now, because there are pending incoming changes that have not been synchronised to Omnia yet." as LocaleString,
            "Please use the Import module to import the pending changes, then try exporting again." as LocaleString
        ],
        error: true,
    },

    pending_outgoing_changes: {
        msg: [
            "A synchronisation request is already being executed now." as LocaleString,
            "Please try again later." as LocaleString
        ],
        error: true
    }


}

export function getSyncMessage(id: string) {

    const msg = messages[id]

    return msg
        ? { ...msg }
        : undefined

}
